// extracted by mini-css-extract-plugin
export default {"largestBubbleContainer":"largestbubble_largestBubbleContainer__HzJTa"};